module.exports = __webpack_public_path__ + "01ea978f/img/google.68f3823e.svg";